import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { Panel, PanelEmpty, rowClass } from './Panel';
import { initials, relativeAgo } from '../../../utils/adminDates';
import type { Enquiry, EnquiryStatus } from '../../../types/admin';
const labels: Record<EnquiryStatus, {
  text: string;
  tone: string;
}> = {
  'Ny henvendelse': {
    text: 'Ny',
    tone: 'border-transparent bg-accent text-white'
  },
  Accepteret: {
    text: 'Accepteret',
    tone: 'border-status-ok/35 bg-status-ok/10 text-status-ok'
  },
  Behandlet: {
    text: 'Behandlet',
    tone: 'border-status-info/35 bg-status-info/10 text-status-info'
  },
  Afvist: {
    text: 'Afvist',
    tone: 'border-line bg-canvas-deep text-ink-muted'
  },
  Uploader: {
    text: 'Uploader',
    tone: 'border-line bg-canvas-deep text-ink-muted'
  }
};
export function LatestEnquiriesPanel({
  enquiries
}: {
  enquiries: Enquiry[];
}) {
  return <Panel title="Seneste henvendelser" linkLabel="Se alle" linkTo="/admin/henvendelser" data-id="element-320" data-mp="2zq010lp1p4qb">
      {enquiries.length === 0 ? <PanelEmpty data-id="element-321" data-mp="3wh7su4am9h2">Ingen henvendelser endnu.</PanelEmpty> : <ul className="divide-y divide-line/70" data-id="element-322" data-mp="7yb5qun3szdj">
          {enquiries.map(item => {
        const label = labels[item.status];
        return <li key={item.id} data-id="element-323" data-mp="cvujzujsxc5h">
                <Link to="/admin/henvendelser" className={rowClass} data-id="element-324" data-mp="hwrzfzdffs3a">
                  <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-line bg-canvas-deep text-sm font-semibold text-ink-soft" aria-hidden="true" data-id="element-325" data-mp="huxnhak4vabc">
                    {initials(item.name)}
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-326" data-mp="3v3a8lwv6c6l2">
                    <span className="block truncate text-[15px] font-semibold text-ink" data-id="element-327" data-mp="3v54tjb6g3yp5">{item.name}</span>
                    <span className="block truncate text-sm text-ink-muted" data-id="element-328" data-mp="2xnwcw9n56o5y">{item.description}</span>
                  </span>
                  <span className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-medium ${label.tone}`} data-id="element-329" data-mp="32kwmguj7a91t">
                    {label.text}
                  </span>
                  <span className="hidden w-24 shrink-0 text-right text-sm text-ink-muted sm:block" data-id="element-330" data-mp="34b1o5o87uequ">
                    {relativeAgo(item.createdAt)}
                  </span>
                  <ChevronRightIcon className="h-4 w-4 shrink-0 text-ink-faint transition-colors duration-150 group-hover:text-accent" aria-hidden="true" data-id="element-331" data-mp="2bn5w4wtldb0e" />
                </Link>
              </li>;
      })}
        </ul>}
    </Panel>;
}